import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Restaurante = () => {
  const [showDietaryInfo, setShowDietaryInfo] = useState(false);

  // Imágenes desde Unsplash para evitar errores de compilación mientras agregas las tuyas
  const moleImg = "https://images.unsplash.com/photo-1588168333986-5078d3ae3976?auto=format&fit=crop&w=800&q=80";
  const cochinitaImg = "https://images.unsplash.com/photo-1628198755074-cecb01a35dc4?auto=format&fit=crop&w=800&q=80";
  const pescadoImg = "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?auto=format&fit=crop&w=800&q=80";
  const huevosImg = "https://images.unsplash.com/photo-1525351484163-c529a9bf47eb?auto=format&fit=crop&w=800&q=80";
  const chilaquilesImg = "https://images.unsplash.com/photo-1626075678441-26c7da44d49a?auto=format&fit=crop&w=800&q=80";
  const flanImg = "https://images.unsplash.com/photo-1542010589005-d1eacc3918f2?auto=format&fit=crop&w=800&q=80";
  const cocinaBarroImg = "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=1200&q=80";
  const heroImg = "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1920&q=80";

  const galleryImages = [
    { id: 1, src: moleImg, alt: "Platillo Tradicional" },
    { id: 2, src: cochinitaImg, alt: "Cocción en Barro" },
    { id: 3, src: pescadoImg, alt: "Ingredientes Frescos" },
    { id: 4, src: huevosImg, alt: "Desayuno de Rancho" },
    { id: 5, src: chilaquilesImg, alt: "Salsas Artesanales" },
    { id: 6, src: flanImg, alt: "Postres Caseros" }
  ];

  const dietaryInfo = {
    alergias: [
      '🌾 Gluten (tenemos opciones de maíz criollo)',
      '🥛 Lactosa (disponemos de platillos sin lácteos)',
      '🥜 Frutos secos (el mole y algunas salsas los contienen)',
      '🌶️ Sensibilidad al picante (preparamos salsas aparte)'
    ],
    preferencias: [
      '🌱 Vegetariano (amplia variedad de guisos sin carne)',
      '🌿 Vegano (podemos adaptar guarniciones y platillos)',
      '🩵 Diabético (postres y bebidas sin azúcar disponible)',
      '⚖️ Bajo en sodio (disponible bajo pedido anticipado)'
    ]
  };

  return (
    <>
      <style>{`
        :root {
          --primary-color: #8B4513;
          --primary-hover: #A0522D;
          --secondary-color: #D2B48C;
          --dark-bg: #1A1A1A;
          --light-bg: #F9F6F0;
          --text-main: #2C2C2C;
          --text-light: #666666;
          --white: #FFFFFF;
          --radius-md: 12px;
          --radius-lg: 24px;
          --shadow-sm: 0 4px 6px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 10px 30px rgba(0, 0, 0, 0.08);
          --shadow-lg: 0 20px 40px rgba(0, 0, 0, 0.12);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .restaurante-page {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          background-color: var(--light-bg);
          color: var(--text-main);
        }

        /* HERO SECTION */
        .restaurante-hero {
          position: relative;
          height: 70vh;
          min-height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: var(--white);
          overflow: hidden;
        }

        .restaurante-hero::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(26,26,26,0.9));
          z-index: 1;
        }

        .restaurante-hero-bg {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          object-fit: cover;
          z-index: 0;
        }

        .restaurante-hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          padding: 0 2rem;
        }

        .hero-badge {
          display: inline-block;
          background: rgba(210, 180, 140, 0.2);
          border: 1px solid var(--secondary-color);
          color: var(--secondary-color);
          padding: 0.5rem 1.5rem;
          border-radius: 50px;
          font-size: 0.9rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(5px);
        }

        .restaurante-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: 4rem;
          line-height: 1.1;
          margin-bottom: 1.5rem;
        }

        .restaurante-hero p {
          font-size: 1.2rem;
          color: #E0E0E0;
          margin-bottom: 2.5rem;
          line-height: 1.6;
        }

        .btn-gold {
          background-color: var(--secondary-color);
          color: var(--dark-bg);
          padding: 1.2rem 3rem;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 700;
          font-size: 1.1rem;
          border: none;
          cursor: pointer;
          transition: var(--transition);
          display: inline-block;
        }

        .btn-gold:hover {
          background-color: var(--white);
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.2);
        }

        /* ABOUT SECTION */
        .restaurante-about {
          padding: 6rem 5%;
          background: var(--white);
        }

        .restaurante-about-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 5rem;
          align-items: center;
        }

        .about-badge {
          color: var(--primary-color);
          font-size: 0.9rem;
          font-weight: 800;
          letter-spacing: 4px;
          text-transform: uppercase;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .about-badge::before {
          content: "";
          display: block;
          width: 40px;
          height: 2px;
          background-color: var(--primary-color);
        }

        .restaurante-about h2 {
          font-family: 'Playfair Display', serif;
          font-size: 3rem;
          color: var(--text-main);
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .restaurante-about p {
          font-size: 1.1rem;
          color: var(--text-light);
          line-height: 1.8;
          margin-bottom: 1.5rem;
        }

        .restaurante-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
          margin-top: 3rem;
          padding-top: 3rem;
          border-top: 1px solid #E0E0E0;
        }

        .stat {
          display: flex;
          flex-direction: column;
        }

        .stat-number {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          font-weight: 700;
          color: var(--primary-color);
          line-height: 1;
          margin-bottom: 0.5rem;
        }

        .stat-label {
          font-size: 0.9rem;
          color: var(--text-light);
          font-weight: 600;
          text-transform: uppercase;
        }

        .restaurante-about-image {
          position: relative;
          border-radius: var(--radius-lg);
          overflow: hidden;
          box-shadow: var(--shadow-lg);
          aspect-ratio: 4/5;
        }

        .restaurante-about-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* PRICE BANNER (NEW) */
        .price-banner {
          background-color: var(--dark-bg);
          color: var(--white);
          padding: 4rem 5%;
          text-align: center;
          background-image: radial-gradient(circle at center, #2a2a2a 0%, #1a1a1a 100%);
        }

        .price-banner-content {
          max-width: 800px;
          margin: 0 auto;
          border: 2px solid rgba(210, 180, 140, 0.3);
          padding: 3rem;
          border-radius: var(--radius-lg);
          position: relative;
        }

        .price-icon {
          position: absolute;
          top: -25px;
          left: 50%;
          transform: translateX(-50%);
          background: var(--dark-bg);
          padding: 0 20px;
          font-size: 2rem;
        }

        .price-banner h3 {
          font-family: 'Playfair Display', serif;
          color: var(--secondary-color);
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        .price-amount {
          font-size: 4rem;
          font-weight: 800;
          color: var(--white);
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .price-amount span {
          font-size: 1.5rem;
          font-weight: 400;
          color: #A0A0A0;
        }

        .price-condition {
          color: #E57373;
          font-weight: bold;
          font-size: 1.1rem;
          letter-spacing: 1px;
          margin-top: 1rem;
          padding-top: 1.5rem;
          border-top: 1px solid rgba(255,255,255,0.1);
        }

        /* GALLERY SECTION */
        .buffet-gallery {
          padding: 6rem 5%;
          background: var(--light-bg);
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-header h2 {
          font-family: 'Playfair Display', serif;
          font-size: 3rem;
          color: var(--dark-bg);
          margin-bottom: 1rem;
        }

        .section-header p {
          color: var(--text-light);
          font-size: 1.1rem;
        }

        .gallery-grid {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 1.5rem;
        }

        .gallery-item {
          border-radius: var(--radius-md);
          overflow: hidden;
          box-shadow: var(--shadow-sm);
          aspect-ratio: 4/3;
          position: relative;
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .gallery-item:hover img {
          transform: scale(1.08);
        }

        /* DIETARY SECTION */
        .dietary-section {
          padding: 4rem 5%;
          background: var(--white);
        }

        .dietary-container {
          max-width: 1000px;
          margin: 0 auto;
          background: var(--light-bg);
          border-radius: var(--radius-lg);
          padding: 2rem;
          border: 1px solid rgba(139, 69, 19, 0.1);
        }

        .dietary-toggle {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: none;
          border: none;
          color: var(--dark-bg);
          font-family: 'Playfair Display', serif;
          font-size: 1.5rem;
          font-weight: 600;
          cursor: pointer;
          padding: 1rem;
        }

        .dietary-toggle span.icon {
          color: var(--primary-color);
          transition: transform 0.3s ease;
        }

        .dietary-toggle span.icon.open {
          transform: rotate(180deg);
        }

        .dietary-content {
          padding: 2rem 1rem 1rem;
          border-top: 1px solid rgba(139, 69, 19, 0.1);
          margin-top: 1rem;
        }

        .dietary-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
        }

        .dietary-list h4 {
          color: var(--primary-color);
          font-size: 1.2rem;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .dietary-list ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .dietary-list li {
          color: var(--text-main);
          margin-bottom: 1rem;
          font-size: 0.95rem;
          padding-left: 1.5rem;
          position: relative;
        }

        .dietary-note {
          background: #FFF3E0;
          padding: 1.5rem;
          border-radius: var(--radius-md);
          border-left: 4px solid #E65100;
          margin-top: 3rem;
          font-size: 0.9rem;
          color: #E65100;
          line-height: 1.6;
        }

        /* INFO & RESERVATION SECTION */
        .info-reservation {
          padding: 6rem 5%;
          background: var(--dark-bg);
          color: var(--white);
        }

        .info-res-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 4rem;
        }

        .info-cards {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .info-card {
          background: rgba(255,255,255,0.05);
          padding: 2rem;
          border-radius: var(--radius-md);
          border: 1px solid rgba(255,255,255,0.1);
        }

        .info-card h4 {
          color: var(--secondary-color);
          font-size: 1.2rem;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .info-card p {
          color: #CCCCCC;
          margin-bottom: 0.5rem;
          line-height: 1.6;
        }

        .reservation-box {
          background: var(--white);
          color: var(--text-main);
          padding: 4rem;
          border-radius: var(--radius-lg);
        }

        .reservation-box h3 {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          margin-bottom: 1rem;
        }

        .reservation-box p.subtitle {
          color: var(--text-light);
          margin-bottom: 2.5rem;
        }

        .contact-methods {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .contact-method {
          display: flex;
          gap: 1rem;
        }

        .cm-icon {
          font-size: 2rem;
          color: var(--primary-color);
        }

        .cm-details h5 {
          font-size: 1rem;
          margin-bottom: 0.3rem;
        }

        .cm-details p {
          color: var(--text-light);
          font-size: 0.95rem;
        }

        .requirements-list {
          background: var(--light-bg);
          padding: 2rem;
          border-radius: var(--radius-md);
          margin-bottom: 3rem;
        }

        .requirements-list h5 {
          color: var(--primary-color);
          margin-bottom: 1rem;
          font-size: 1.1rem;
        }

        .requirements-list ul {
          color: var(--text-main);
          padding-left: 1.2rem;
        }

        .requirements-list li {
          margin-bottom: 0.5rem;
        }

        @media (max-width: 968px) {
          .restaurante-about-container, .info-res-container {
            grid-template-columns: 1fr;
          }
          
          .restaurante-hero h1 { font-size: 3rem; }
          .price-amount { font-size: 3rem; }
          .dietary-grid, .contact-methods { grid-template-columns: 1fr; gap: 2rem;}
          .reservation-box { padding: 2rem; }
        }
      `}</style>

      <div className="restaurante-page">
        {/* HERO SECTION */}
        <section className="restaurante-hero">
          <img src={heroImg} alt="Cocina de Humo" className="restaurante-hero-bg" />
          <div className="restaurante-hero-content">
            <span className="hero-badge">Xicotepec, Puebla</span>
            <h1>Cocina Tradicional de Humo</h1>
            <p>Sabores ancestrales cocinados lentamente en ollas de barro al calor de la leña, donde el café es nuestro ingrediente secreto.</p>
            <button 
              className="btn-gold"
              onClick={() => document.getElementById('buffet-gallery')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Ver Galería
            </button>
          </div>
        </section>

        {/* ABOUT SECTION */}
        <section className="restaurante-about">
          <div className="restaurante-about-container">
            <div className="restaurante-about-content">
              <span className="about-badge">Nuestra Esencia</span>
              <h2>La Magia del Barro y la Leña</h2>
              <p>
                En Román Valderrábano, rescatamos las técnicas de nuestros antepasados. 
                Toda nuestra comida se prepara en <strong>ollas de barro cocido</strong> sobre fogones 
                de leña de la región.
              </p>
              <p>
                Esta técnica de "cocina de humo" no solo sella los jugos y nutrientes de los alimentos, 
                sino que les aporta notas ahumadas inconfundibles. Además, integramos sutilmente nuestro 
                café de altura en marinados, salsas y postres, creando una experiencia gastronómica 
                que no encontrarás en ningún otro lugar.
              </p>
              
              <div className="restaurante-stats">
                <div className="stat">
                  <span className="stat-number">100%</span>
                  <span className="stat-label">Cocción en Barro</span>
                </div>
                <div className="stat">
                  <span className="stat-number">0</span>
                  <span className="stat-label">Conservadores</span>
                </div>
                <div className="stat">
                  <span className="stat-number">10</span>
                  <span className="stat-label">Personas Mínimo</span>
                </div>
              </div>
            </div>
            
            <div className="restaurante-about-image">
              <img src={cocinaBarroImg} alt="Ollas de barro en fogón" />
            </div>
          </div>
        </section>

        {/* PRICE BANNER (TARIFA ÚNICA) */}
        <section className="price-banner">
          <div className="price-banner-content">
            <span className="price-icon">🏺</span>
            <h3>Experiencia Buffet Completa</h3>
            <p style={{marginBottom: '2rem', color: '#CCC', fontSize: '1.1rem'}}>Disfruta de todos nuestros platillos tradicionales, guarniciones y postres.</p>
            
            <div className="price-amount">
              $200 <span>MXN / por persona</span>
            </div>
            
            <p>Precio único válido para cualquier horario (Desayuno, Comida o Cena).</p>
            
            <div className="price-condition">
              ⚠️ PARA ABRIR LA COCINA, SE REQUIERE RESERVACIÓN DE UN GRUPO MÍNIMO DE 10 PERSONAS.
            </div>
          </div>
        </section>

        {/* GALLERY SECTION */}
        <section id="buffet-gallery" className="buffet-gallery">
          <div className="section-header">
            <h2>Galería de Nuestra Cocina</h2>
            <p>Un vistazo a nuestra auténtica cocina de humo en ollas de barro. Nuestro menú es personalizado según tu evento.</p>
          </div>

          <div className="gallery-grid">
            {galleryImages.map(img => (
              <div key={img.id} className="gallery-item">
                <img src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </section>

        {/* DIETARY INFO SECTION */}
        <section className="dietary-section">
          <div className="dietary-container">
            <button 
              className="dietary-toggle"
              onClick={() => setShowDietaryInfo(!showDietaryInfo)}
            >
              Alergias y Preferencias Alimenticias
              <span className={`icon ${showDietaryInfo ? 'open' : ''}`}>▼</span>
            </button>
            
            {showDietaryInfo && (
              <div className="dietary-content">
                <p style={{marginBottom: '2rem', color: 'var(--text-light)', fontSize: '1.05rem'}}>
                  En Román Valderrábano nos preocupamos por tu bienestar. Si tú o alguien de tu grupo 
                  tiene alguna restricción, avísanos al reservar y nuestro chef ajustará el menú.
                </p>
                
                <div className="dietary-grid">
                  <div className="dietary-list">
                    <h4>🚨 Alergias comunes consideradas</h4>
                    <ul>
                      {dietaryInfo.alergias.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="dietary-list">
                    <h4>🌱 Adaptaciones para tu estilo de vida</h4>
                    <ul>
                      {dietaryInfo.preferencias.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                
                <div className="dietary-note">
                  <strong>Aviso de cuidado:</strong> Nuestra cocina procesa ingredientes locales 
                  y café. Aunque somos sumamente cuidadosos, no podemos garantizar un ambiente 
                  100% libre de trazas por contacto cruzado. Por favor, evalúa tu nivel de 
                  sensibilidad.
                </div>
              </div>
            )}
          </div>
        </section>

        {/* INFO & RESERVATION */}
        <section className="info-reservation">
          <div className="info-res-container">
            
            <div className="info-cards">
              <div className="info-card">
                <h4><span>📍</span> Ubicación</h4>
                <p>Zaragoza 146, Col. Centro</p>
                <p>Xicotepec de Juárez, Puebla</p>
                <p>C.P. 73080</p>
              </div>
              
              <div className="info-card">
                <h4><span>⏰</span> Horarios de Atención</h4>
                <p><strong>Lunes a Sábado:</strong> 8:00 am - 6:00 pm</p>
                <p style={{marginTop: '10px', fontSize: '0.9rem', color: 'var(--secondary-color)'}}>
                  * Los horarios del buffet se acuerdan al momento de tu reservación (Desayuno, Comida o Cena).
                </p>
              </div>

              <div className="info-card">
                <h4><span>🎉</span> Eventos Especiales</h4>
                <p>Ideal para reuniones familiares, eventos corporativos o celebraciones.</p>
                <p>Capacidad máxima: 50 personas.</p>
              </div>
            </div>

            <div className="reservation-box">
              <h3>Agenda tu visita</h3>
              <p className="subtitle">Comunícate con nosotros para verificar disponibilidad de fechas.</p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="cm-icon">📞</div>
                  <div className="cm-details">
                    <h5>Teléfono / WhatsApp</h5>
                    <p>+52 1 764 105 7461</p>
                  </div>
                </div>
                
                <div className="contact-method">
                  <div className="cm-icon">✉️</div>
                  <div className="cm-details">
                    <h5>Email</h5>
                    <p>romanvalderrabanoelcatador@gmail.com</p>
                  </div>
                </div>
              </div>

              <div className="requirements-list">
                <h5>📋 Requisitos Indispensables</h5>
                <ul>
                  <li><strong>Mínimo 10 personas para abrir la cocina.</strong></li>
                  <li>Costo: $200 MXN por persona.</li>
                  <li>Reservación requerida con al menos 48 horas de anticipación.</li>
                  <li>Anticipo del 50% para confirmar el evento.</li>
                </ul>
              </div>

              <a 
                href="https://wa.me/5217641057461?text=Hola,%20me%20gustaría%20solicitar%20información%20para%20reservar%20el%20Buffet%20de%20Cocina%20de%20Humo." 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-gold" 
                style={{width: '100%', textAlign: 'center'}}
              >
                Reservar vía WhatsApp
              </a>
            </div>

          </div>
        </section>

      </div>
    </>
  );
};

export default Restaurante;